import { useSelectedAlert } from '~/stores/navigationStore';

import ErrorBoundary from './ErrorBoundary';

type ErrorBoundaryProps = Readonly<
  Omit<React.ComponentProps<typeof ErrorBoundary>, 'selectedAlert'>
>;

export default function ErrorBoundaryHOC(props: ErrorBoundaryProps) {
  const selectedAlert = useSelectedAlert();

  return <ErrorBoundary {...props} selectedAlert={selectedAlert} />;
}
